import moment from "moment";
import defaultImage from "@/assets/defaultImage.png";
import storeImage from "@/assets/pmarketlogoonly.png";

const filters = {
  timeSimple(value) {
    if (value) {
      return moment(value).format("HH:mm");
    } else {
      return "-";
    }
  },
  timeSimpleUtc(value) {
    if (value) {
      return moment.utc(value).format("HH:mm");
    } else {
      return "-";
    }
  },
  dateFull(value, options = { separator: "-" }) {
    if (value && value != "0001-01-01T00:00:00Z") {
      if (options.separator) {
        return moment(value).format(`DD MMM YYYY ${options.separator} HH:mm`);
      }
      return moment(value).format("DD MMM YYYY HH:mm");
    } else {
      return "-";
    }
  },
  dateSimple(value) {
    if (value) {
      return moment(value).format("DD MMM YYYY");
    } else {
      return "-";
    }
  },
  dateSimple2(value) {
    if (value) {
      return moment(value).format("DD/MM/YYYY");
    } else {
      return "-";
    }
  },
  isoDate(value) {
    if (value) {
      return moment(value).format("YYYY-MM-DD");
    } else {
      return "-";
    }
  },
  dateToDay(value) {
    if (value) {
      return moment(value).format("dddd");
    } else {
      return "-";
    }
  },
  dateAndMonth(value) {
    if (value) {
      return moment(value).format("DD-MMM");
    } else {
      return "-";
    }
  },
  dateAndMonthUtc(value) {
    if (value) {
      return moment.utc(value).format("DD-MMM");
    } else {
      return "-";
    }
  },
  rupiah(value) {
    if (value) {
      let tempValue = value;
      let isNegative = !isNaN(value) && value < 0;
      if (isNegative) tempValue = Math.abs(value);
      let number_string = tempValue.toString();
      let parseRp =
        Number(number_string.replace(/Rp/gi, ""))?.toFixed(0)?.toString() ||
        "0";

      let sisa = parseRp.length % 3;
      let rupiah = parseRp.substr(0, sisa);
      let ribuan = parseRp.substr(sisa).match(/\d{3}/g);

      if (ribuan) {
        let separator = sisa ? "." : "";
        rupiah += separator + ribuan.join(".");
      }

      return `${isNegative ? "-" : ""}Rp${rupiah}`;
    } else {
      return "Rp" + (value || 0);
    }
  },
  handleNumberKeypress(e) {
    const keysAllowed = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
    const keyPressed = e.key;

    if (!keysAllowed.includes(keyPressed)) {
      e.preventDefault();
    }
  },
  isNumber(num) {
    return (
      (typeof num === "number" ||
        (typeof num === "string" && num.trim() !== "")) &&
      !isNaN(num)
    );
  },
  isStringSame(firstVal, secondVal, options = { trim: false, number: false }) {
    if (options.number) {
      return Number(firstVal) === Number(secondVal);
    }
    if (options.trim) {
      return (
        firstVal?.replaceAll(/[\r\n]/g, "") ===
        secondVal?.replaceAll(/[\r\n]/g, "")
      );
    }
    return firstVal === secondVal;
  },
  imageParse(path) {
    if (!path || path === "-") return defaultImage;
    if (typeof path === "string" && !path.includes("http")) {
      return process.env.VUE_APP_STORAGE + path;
    }

    return path;
  },
  storeImageParse(path) {
    if (!path || path === "-") return storeImage;
    if (typeof path === "string" && !path.includes("http")) {
      return process.env.VUE_APP_STORAGE + path;
    }

    return path;
  },
  validateDate(date) {
    if (date == "0001-01-01T00:00:00Z") {
      return "";
    } else {
      return date;
    }
  },
  capitalize(str) {
    if (!str) return "";
    return str
      .split(" ")
      .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
      .join(" ");
  },
  validateEmail(email) {
    if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)) {
      return true;
    }
    return false;
  },
  arrToString(array) {
    if (array.length > 0) {
      return array.join(", ");
    }
  },
  richContentToString(htmlString) {
    // Create a temporary DOM element to parse the HTML string
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    // Recursive function to get text content from all child nodes
    const getTextContent = (node) => {
      let text = "";
      node.childNodes.forEach((child) => {
        if (child.nodeType === Node.TEXT_NODE) {
          text += child.textContent.trim() + " ";
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          text += getTextContent(child);
        }
      });
      return text;
    };

    // Get the text content from the temporary div
    const inlineString = getTextContent(tempDiv).trim();
    return inlineString;
  },
};

export default filters;
